import { useEffect, useState } from "react";
import { DropdownItem } from "../ui/dropdown/DropdownItem";
import { Dropdown } from "../ui/dropdown/Dropdown";
import { Link, useNavigate } from "react-router-dom";
import { logout as superAdminLogout} from "../../redux/slices/superAdminSlice";
import { useDispatch } from "react-redux";
import { logout as adminLogout } from "../../redux/slices/adminSlice";
import { logout } from "../../redux/slices/employeeSlice";
import Modal from "../common/Modal";
import ChangePasswordModal from "../modals/ChangePasswordModal";

export default function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [logo, setLogo] = useState("https://stellarflux.com/_next/static/media/logo-white.3de6538f.png")
  function toggleDropdown() {
    setIsOpen(!isOpen);
  }
  const navigate = useNavigate()
  const dispatch = useDispatch();

  function closeDropdown() {
    setIsOpen(false);
  }

  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
    closeDropdown();
  };

  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
  };
   useEffect(() => {
      let getLogoFromLocalStorage = localStorage.getItem("logo");
      if (getLogoFromLocalStorage) {
        setLogo(getLogoFromLocalStorage);
      } else {
        let logo = require("../../assets/images/default.png")
        setLogo(logo);
      }
  }, []);

  const handleLogout =()=>{
    const user = localStorage.getItem("user");
    let userData = JSON.parse(user);
    if(userData?.role === "superAdmin"){
      dispatch(superAdminLogout());
    }else if(userData?.role === "admin"){
     dispatch(adminLogout());
    }else if(userData?.role === "employee"){
      dispatch(logout());
    }
  }
  const handleProfile = () => {
    closeDropdown();
  }

  // Check if current user is an employee
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const isEmployee = currentUser?.role === "employee";

  return (
    <div className="relative z-[9999999]">
      <button
        onClick={toggleDropdown}
        className="flex items-center rounded-lg py-1 text-gray-700 dropdown-toggle dark:text-gray-400"
      >
        <span className="overflow-hidden rounded-full h-11 w-11">
          <img src={logo}  alt="User" />
        </span>
        <svg
          className={`stroke-gray-500 dark:stroke-gray-400 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
          width="18"
          height="20"
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.3125 8.65625L9 13.3437L13.6875 8.65625"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={closeDropdown}
        className=" right-0  mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-1 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark absolute z-[99999999999]!"
      >
         <Link
          onClick={handleProfile}
          to="/employee/profile"
          className="flex items-center gap-3 px-3 py-1 mt-1 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300"
        >
          <svg
          className="fill-gray-500 group-hover:fill-gray-700 dark:group-hover:fill-gray-300"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.314 0-10 1.657-10 5v3h20v-3c0-3.343-6.686-5-10-5z"
            fill="currentColor"
          />
        </svg>
          Profile
        </Link>
        {/* Change Password option - only for employees */}
        {isEmployee && (
          <button
            onClick={openPasswordModal}
            className="flex items-center gap-3 px-3 py-1 mt-1 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300"
          >
            <svg
              className="fill-gray-500 group-hover:fill-gray-700 dark:group-hover:fill-gray-300"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 10.5V8C17 5.24 14.76 3 12 3S7 5.24 7 8V10.5C6.45 10.5 6 10.95 6 11.5V19.5C6 20.05 6.45 20.5 7 20.5H17C17.55 20.5 18 20.05 18 19.5V11.5C18 10.95 17.55 10.5 17 10.5ZM12 15.5C11.45 15.5 11 15.05 11 14.5S11.45 13.5 12 13.5S13 13.95 13 14.5S12.55 15.5 12 15.5ZM15 10.5H9V8C9 6.34 10.34 5 12 5S15 6.34 15 8V10.5Z"
                fill=""
              />
            </svg>
            Change Password
          </button>
        )}
        
        <Link
          onClick={handleLogout}
          className="flex items-center gap-3 px-3 py-1 mt-1 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-gray-300"
        >
          <svg
            className="fill-gray-500 group-hover:fill-gray-700 dark:group-hover:fill-gray-300"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.1007 19.247C14.6865 19.247 14.3507 18.9112 14.3507 18.497L14.3507 14.245H12.8507V18.497C12.8507 19.7396 13.8581 20.747 15.1007 20.747H18.5007C19.7434 20.747 20.7507 19.7396 20.7507 18.497L20.7507 5.49609C20.7507 4.25345 19.7433 3.24609 18.5007 3.24609H15.1007C13.8581 3.24609 12.8507 4.25345 12.8507 5.49609V9.74501L14.3507 9.74501V5.49609C14.3507 5.08188 14.6865 4.74609 15.1007 4.74609L18.5007 4.74609C18.9149 4.74609 19.2507 5.08188 19.2507 5.49609L19.2507 18.497C19.2507 18.9112 18.9149 19.247 18.5007 19.247H15.1007ZM3.25073 11.9984C3.25073 12.2144 3.34204 12.4091 3.48817 12.546L8.09483 17.1556C8.38763 17.4485 8.86251 17.4487 9.15549 17.1559C9.44848 16.8631 9.44863 16.3882 9.15583 16.0952L5.81116 12.7484L16.0007 12.7484C16.4149 12.7484 16.7507 12.4127 16.7507 11.9984C16.7507 11.5842 16.4149 11.2484 16.0007 11.2484L5.81528 11.2484L9.15585 7.90554C9.44864 7.61255 9.44847 7.13767 9.15547 6.84488C8.86248 6.55209 8.3876 6.55226 8.09481 6.84525L3.52309 11.4202C3.35673 11.5577 3.25073 11.7657 3.25073 11.9984Z"
              fill=""
            />
          </svg>
          Sign out
        </Link>
      </Dropdown>

      {/* Change Password Modal */}
      <Modal 
        isOpen={isPasswordModalOpen} 
        onClose={closePasswordModal}
        size="md"
      >
        <ChangePasswordModal 
          onClose={closePasswordModal}
          onSuccess={closePasswordModal}
        />
      </Modal>
    </div>
  );
}
